import { render, staticRenderFns } from "./FullMomentumDashboard.vue?vue&type=template&id=2c7b3a08&"
import script from "./FullMomentumDashboard.vue?vue&type=script&lang=js&"
export * from "./FullMomentumDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports